import React from 'react';
import { useSelectPersonFieldQuery } from 'generated/graphql';

export type IData = {
  id: string;
  label: string;
};

export function useQuery(freeText: string) {
  const tuple = useSelectPersonFieldQuery({
    variables: {
      options: {
        filter: {
          omniFreeText: freeText,
          isActive: true
        }
      }
    }

  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.persons?.filter((node) => node.isActive).map((node) => ({
        id: node?.id ?? '',
        label: node?.fullName ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
